import axios from "axios";
import React from "react";
import { useState } from "react";
import { API_BASE_URL, IMG_API } from "../../api/endPoint";
import get from "../../features/get";

export default function AddplayerRating({ data, modal }) {
  function handleClose() {
    modal(false);
  }
  const positions = get?.Getpositions();
  const teams = get?.Getteam();
  const [pace, setPace] = useState(data?.pace == null ? 0 : data?.pace);
  const [dribbling, setdribbling] = useState(
    data?.dribbling == null ? 0 : data?.dribbling
  );
  const [shooting, setShooting] = useState(
    data?.shooting == null ? 0 : data?.shooting
  );
  const [defending, setDefending] = useState(
    data?.defending == null ? 0 : data?.defending
  );
  const [passing, setPassing] = useState(
    data?.passing == null ? 0 : data?.passing
  );
  const [physical, setPhysical] = useState(
    data?.physical == null ? 0 : data?.physical
  );
  const [acceleration, setAcceleration] = useState(
    data?.acceleration == null ? 0 : data?.acceleration
  );
  const [aggression, setAggression] = useState(
    data?.aggression == null ? 0 : data?.aggression
  );
  const [agility, setAgility] = useState(
    data?.agility == null ? 0 : data?.agility
  );
  const [curve, setCurve] = useState(data?.curve == null ? 0 : data?.curve);
  const [free_kick, setFreeKick] = useState(
    data?.free_kick == null ? 0 : data?.free_kick
  );
  const [heading, setHeading] = useState(
    data?.heading == null ? 0 : data?.heading
  );
  const [crossing, setCrossing] = useState(
    data?.crossing == null ? 0 : data?.crossing
  );
  const [finishing, setFinishing] = useState(
    data?.finishing == null ? 0 : data?.finishing
  );
  const [marking, setMarking] = useState(
    data?.marking == null ? 0 : data?.marking
  );
  const [image, setImage] = useState({ preview: "", data: "" });

  const handleChange = function loadFile(e) {
    const img = {
      preview: URL.createObjectURL(e.target.files[0]),
      data: e.target.files[0],
    };
    setImage(img);
  };
  let overall = [
    Number(pace),
    Number(dribbling),
    Number(shooting),
    Number(defending),
    Number(passing),
    Number(physical),
    Number(acceleration),
    Number(aggression),
    Number(agility),
    Number(curve),
    Number(free_kick),
    Number(heading),
    Number(crossing),
    Number(finishing),
    Number(marking),
  ];
  function calculateoverall(overall) {
    var total = 0;
    var count = 0;

    overall.forEach(function (item, index) {
      total = total + item;
      count++;
    });

    return total / count;
  }

  console.log(~~calculateoverall(overall), "overall");
  let user = {
    pace,
    dribbling,
    shooting,
    defending,
    passing,
    physical,
    acceleration,
    aggression,
    agility,
    curve,
    free_kick,
    heading,
    crossing,
    finishing,
    marking,
    userid: data?.player_id,
    overall: ~~calculateoverall(overall),
  };

  const handleCreate = (e) => {
    e.preventDefault();
    axios
      .post(`${API_BASE_URL}create/playerrating`, user, {})
      .then((res) => console.log(res, "back end response"))
      .catch((err) => console.log(err, "error back end response"));
  };
  console.log(data, "users");
  const handleUpdate = (e) => {
    e.preventDefault();
    axios
      .put(`${API_BASE_URL}update/playerrating/${data?.id}`, user, {})
      .then((res) => console.log(res, "back end response"))
      .catch((err) => console.log(err, "error back end response"));
  };
  console.log(data, "users");
  return (
    <div
      className="relative z-10"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
      onClick={handleClose}
    >
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

      <div className="fixed inset-0 z-10 overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div
            onClick={(e) => e.stopPropagation()}
            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg"
          >
            <div className="">
              <h1 className="py-2 px-5">
                {data?.userid == null
                  ? "Add Player Rating"
                  : "Update Player Rating"}
              </h1>
            </div>
            <form onSubmit={data?.pace == null ? handleCreate : handleUpdate}>
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className=" grid gap-3 px-3">
                  <div className="flex justify-center">
                    {data?.avatar != null ? (
                      <div className="w-[110px] h-[110px] border border-black rounded-full  ">
                        <img
                          alt="players"
                          src={`${IMG_API}/${data?.avatar}`}
                          className="rounded-full p-1"
                        />
                      </div>
                    ) : (
                      <div className="">
                        <div className="w-[110px] h-[110px] border border-black rounded-full flex justify-center items-center ">
                          <div className="bg- text-center text-[21px] text-bold">
                            {data?.firstname[0]}
                            {data?.lastname[0]}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="">Over All {~~calculateoverall(overall)}</div>
                  <div className="text-black text-[18px] text-center">
                    {data?.firstname + " " + data?.lastname}
                  </div>
                </div>
                <div className="grid grid-cols-12 gap-3">
                  <div className="col-span-6">
                    <label
                      for="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Pace
                    </label>
                    <input
                      value={pace}
                      onChange={(e) => setPace(e.target.value)}
                      type="number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                    />
                  </div>
                  <div className="col-span-6">
                    <label
                      for="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Dribbling
                    </label>
                    <input
                      value={dribbling}
                      onChange={(e) => setdribbling(e.target.value)}
                      type="number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                    />
                  </div>
                  <div className="col-span-6">
                    <label
                      for="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Shooting
                    </label>
                    <input
                      value={shooting}
                      onChange={(e) => setShooting(e.target.value)}
                      type="number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                    />
                  </div>
                  <div className="col-span-6">
                    <label
                      for="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Defending
                    </label>
                    <input
                      value={defending}
                      onChange={(e) => setDefending(e.target.value)}
                      type="number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                    />
                  </div>
                  <div className="col-span-6">
                    <label
                      for="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Passing
                    </label>
                    <input
                      value={passing}
                      onChange={(e) => setPassing(e.target.value)}
                      type="number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                    />
                  </div>
                  <div className="col-span-6">
                    <label
                      for="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Physical
                    </label>
                    <input
                      value={physical}
                      onChange={(e) => setPhysical(e.target.value)}
                      type="number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                    />
                  </div>
                  <div className="col-span-6">
                    <label
                      for="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Acceleration
                    </label>
                    <input
                      value={acceleration}
                      onChange={(e) => setAcceleration(e.target.value)}
                      type="number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                    />
                  </div>
                  <div className="col-span-6">
                    <label
                      for="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Aggression
                    </label>
                    <input
                      value={aggression}
                      onChange={(e) => setAggression(e.target.value)}
                      type="number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                    />
                  </div>
                  <div className="col-span-6">
                    <label
                      for="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Agility
                    </label>
                    <input
                      value={agility}
                      onChange={(e) => setAgility(e.target.value)}
                      type="number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                    />
                  </div>
                  <div className="col-span-6">
                    <label
                      for="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Curve
                    </label>
                    <input
                      value={curve}
                      onChange={(e) => setCurve(e.target.value)}
                      type="number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                    />
                  </div>
                  <div className="col-span-6">
                    <label
                      for="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Free Kick
                    </label>
                    <input
                      value={free_kick}
                      onChange={(e) => setFreeKick(e.target.value)}
                      type="number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                    />
                  </div>
                  <div className="col-span-6">
                    <label
                      for="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Heading
                    </label>
                    <input
                      value={heading}
                      onChange={(e) => setHeading(e.target.value)}
                      type="number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                    />
                  </div>
                  <div className="col-span-6">
                    <label
                      for="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Crossing
                    </label>
                    <input
                      value={crossing}
                      onChange={(e) => setCrossing(e.target.value)}
                      type="number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                    />
                  </div>
                  <div className="col-span-6">
                    <label
                      for="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Finishing
                    </label>
                    <input
                      value={finishing}
                      onChange={(e) => setFinishing(e.target.value)}
                      type="number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                    />
                  </div>
                  <div className="col-span-6">
                    <label
                      for="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Marking
                    </label>
                    <input
                      value={marking}
                      onChange={(e) => setMarking(e.target.value)}
                      type="number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                <button
                  type="submit"
                  className="inline-flex w-full justify-center rounded-md border border-transparent bg-[#67e8f9] px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-[#22d3ee] focus:outline-none focus:ring-2 focus:ring-[#22d3ee] focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  {data?.userid == null ? "Create" : "Update"}
                </button>
                <button
                  onClick={handleClose}
                  type="button"
                  className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
